/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import 'react-datepicker/dist/react-datepicker.css'
import './DatePicker.scss'
import React, { Component } from 'react'
import ReactDatePicker from 'react-datepicker'

class DatePicker extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      selected: props.selected || new Date().setHours(0, 0, 0),
      styleSelected: props.selected ? 'DatePicker--selected' : '',
      className: props.className || '',
      disabled: props.disabled || false
    }
  }

  handleChange(date, func) {
    const dummyEvent = { target: { name: this.props.name, value: date } }
    func(dummyEvent)
  }

  componentWillReceiveProps(props) {
    this.setState({
      selected: props.selected || new Date().setHours(0, 0, 0),
      styleSelected: props.selected ? 'DatePicker--selected' : ''
    })
  }

  render() {
    let classNameDisabled = ''
    let isClearable = this.props.isClearable
    if (this.props.disabled) {
      isClearable = false
      classNameDisabled = 'DatePicker--disabled'
    }

    return (
      <ReactDatePicker
        name={this.state.name}
        className={`DatePicker ${this.state.className} ${this.state.styleSelected} ${classNameDisabled}`}
        selected={this.props.selected ? this.state.selected : null}
        onChange={date => this.handleChange(date, this.props.onChange)}
        dateFormat={this.props.dateFormat || 'yyyy/MM/dd'}
        todayButton={this.props.todayButton || '今日'}
        showTimeSelect={this.props.showTimeSelect || false}
        timeFormat={this.props.timeFormat || 'HH:mm'}
        timeIntervals={this.props.timeIntervals || 30}
        timeCaption={this.props.timeCaption || '時刻'}
        popperPlacement={this.props.popperPlacement || 'bottom'}
        withPortal={this.props.withPortal || true}
        isClearable={isClearable || false}
        placeholderText={this.props.placeholderText || null}
        disabled={this.props.disabled}
      />
    )
  }
}

export default DatePicker
